import { createFileRoute, redirect } from '@tanstack/react-router'

import i18n from '@/i18n'
import {
  commentFilterSchema,
  CommentsView,
  studentQueryOptions
} from '@/modules/students'
import { semesterQueryOptions } from '@/queries/useSemesters'
import { getMetaWithPageTitle } from '@/utils/get-page-title'
import { isSelectedSemesterInOptions } from '@/utils/is-selected-semester-in-options'

export const Route = createFileRoute(
  '/_auth/students-and-classes/students/$studentId/comments'
)({
  validateSearch: commentFilterSchema,
  component: CommentsView,
  loaderDeps: ({ search }) => ({ search }),
  loader: async ({ deps: { search }, context, params }) => {
    const [semesters, student] = await Promise.all([
      context.queryClient.ensureQueryData(semesterQueryOptions({})),
      context.queryClient.ensureQueryData(studentQueryOptions(params.studentId))
    ])

    if (
      !search.semester ||
      !isSelectedSemesterInOptions(
        search.semester,
        semesters.semestersFromCurrentYearOptions
      )
    ) {
      throw redirect({
        replace: true,
        to: '/students-and-classes/students/$studentId/comments',
        params,
        search: {
          ...search,
          semester: semesters.currentSemester?.id
        }
      })
    }

    return student.fullName
  },
  head: ({ loaderData }) =>
    getMetaWithPageTitle([
      loaderData,
      i18n.t('title.comments', { ns: 'students' })
    ])
})
